/**
 * UniApp API Compatibility Layer
 * Provides uni.* API compatibility for components during migration
 */

import { getStorageSync, setStorageSync, removeStorageSync } from './storage.js'
import { getSystemInfoSync } from './system.js'
import { navigateTo, navigateBack, redirectTo, switchTab, reLaunch } from './navigation.js'
import { showToast, showLoading, hideLoading, showModal } from './ui-compat.js'

// Create uni object for compatibility
const uni = {
  // Storage APIs
  getStorageSync,
  setStorageSync,
  removeStorageSync,
  getStorage: (options) => {
    const value = getStorageSync(options.key)
    if (options.success) {
      options.success({ data: value })
    }
  },
  setStorage: (options) => {
    setStorageSync(options.key, options.data)
    if (options.success) {
      options.success()
    }
  },
  removeStorage: (options) => {
    removeStorageSync(options.key)
    if (options.success) {
      options.success()
    }
  },
  clearStorageSync: () => {
    localStorage.clear()
  },
  clearStorage: (options) => {
    localStorage.clear()
    if (options.success) {
      options.success()
    }
  },

  // System Info
  getSystemInfoSync,
  getSystemInfo: (options) => {
    const info = getSystemInfoSync()
    if (options.success) {
      options.success(info)
    }
  },

  // Navigation
  navigateTo,
  navigateBack,
  redirectTo,
  switchTab,
  reLaunch,

  // UI APIs
  showToast,
  showLoading,
  hideLoading,
  showModal,

  // Request API (will use axios)
  request: (options) => {
    // This will be handled by the request utility
    // For now, return a promise-compatible structure
    return new Promise((resolve, reject) => {
      import('./request.js').then(({ default: http }) => {
        http(options, (error) => {
          if (options.fail) {
            options.fail(error)
          }
          reject(error)
        }, options.context).then((res) => {
          if (options.success) {
            options.success({ data: res, statusCode: 200 })
          }
          resolve(res)
        }).catch((error) => {
          if (options.fail) {
            options.fail(error)
          }
          reject(error)
        })
      })
    })
  },

  // Page API
  $u: {
    route: (options) => {
      navigateTo(options)
    },
    page: () => {
      if (typeof window !== 'undefined' && window.__VUE_ROUTER__) {
        return window.__VUE_ROUTER__.currentRoute.value.path
      }
      return ''
    },
  },
}

// Make uni available globally
if (typeof window !== 'undefined') {
  window.uni = uni
}

export default uni

